import { BsCheckLg } from 'react-icons/bs'
import { BsFillXCircleFill } from 'react-icons/bs'
import { useLang } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'

const UserCreated = ({ ok, subscribeOk, pwdLostReplaced, creationDidFail }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng

  const onCreationDidFail = () => {
    creationDidFail()
  }
  return (
    <>
      {ok === 1 &&
        subscribeOk === -1 && ( //free account not canceled
          <article className="message is-primary">
            <div className="message-header">
              <span className="icon-text">
                <span className="icon ">
                  <BsCheckLg />
                </span>
                <span>{choosenLang.createOkTitle}</span>
              </span>
            </div>
            <div className="message-body">
              <p>{choosenLang.createOK1}</p>
              <p>{choosenLang.createOK2}</p>
              <p>{choosenLang.createOK3}</p>
            </div>
          </article>
        )}
      {ok === 0 && subscribeOk === -1 && pwdLostReplaced === false && (
        <div className="notification is-alert is-light">
          <span className="icon is-small is-left">
            <i className="fa fa-ok"></i>
          </span>
          Raté.
        </div>
      )}
      {ok === 1 && subscribeOk === 1 && (
        /*acccount suscribed*/ <article className="message is-info">
          <div className="message-header">
            <span className="icon-text">
              <span className="icon ">
                <BsCheckLg />
              </span>
              <span>{choosenLang.subscribeOkTitle}</span>
            </span>
          </div>
          <div className="message-body">
            <p>{choosenLang.subscribeOK1}</p>
            <p>{choosenLang.subscribeOK2}</p>
            <p>{choosenLang.subscribeOK3}</p>
          </div>
        </article>
      )}
      {pwdLostReplaced === false &&
        ((ok === 1 && subscribeOk === 0) ||
          (ok === 0 && subscribeOk === 0) ||
          (ok === -1 &&
            subscribeOk ===
              -1) /*account canceled at pwd step, free or payed*/ ||
          (ok === -1 &&
            subscribeOk ===
              0)) /*account canceled at paypal step, by closing window before account, or canceled after account*/ && (
          <>
            <article className="message is-warning">
              <div className="message-header">
                <span className="icon-text">
                  <span className="icon ">
                    <BsFillXCircleFill />
                  </span>
                  <span>{choosenLang.subscribedCanceledTitle}</span>
                </span>
              </div>
              <div className="message-body">
                {choosenLang.subscribeCanceled1}
              </div>
            </article>
            <button className="button is-warning" onClick={onCreationDidFail}>
              {choosenLang.continue}
            </button>
          </>
        )}
      {pwdLostReplaced === true && (
        <article className="message is-info">
          <div className="message-header">
            <span className="icon-text">
              <span className="icon ">
                <BsCheckLg />
              </span>
              <span>{choosenLang.pwdLostReplaced}</span>
            </span>
          </div>
          <div className="message-body">
            <p>{choosenLang.createOK3}</p>
          </div>
        </article>
      )}
    </>
  )
}

export default UserCreated
